export default "__VITE_PUBLIC_ASSET__68387e9d__"